module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-greekhouse-97783354784259867df3f5850d388d17.png";